module.exports = __webpack_public_path__ + "img/brands-mulino-bread.jpg?227d51f570bf12d3a1113ef0d882d086";